<template>
  <Modal 
    v-if="displayError" 
    :config='modalConfig.addPayeeFailure'
    @btn1Action="handleSave()"
    >
    <span slot='modalContent' class='font-weight-medium'
          style="display: block; margin-bottom: 30px;" data-qa="localpaymentsaddpayeefailure-span-3802ss">
        {{ $t("domesticPayments.addNewPayeeErrorBody")}}
    </span>
    <span slot='modalContent' class='font-weight-medium'  data-qa="localpaymentsaddpayeefailure-span-8gaz6p">
        {{ $t("domesticPayments.addNewPayeeError")}}
    </span>
    <span slot='modalContent' class='font-weight-medium red--text'
        style="display: block;" 
        v-show="errors && errors.length"
        v-for="item in errors"
        :key="item.code">
        {{ item.message }}
    </span>
    <span slot='modalContent' class='font-weight-regular' 
        v-if="enableAddPayeeRetryLimit && !retryActive" data-qa="localpaymentsaddpayeefailure-span-cwc3ly">
        {{ this.$t('errors.common.retryLimitReached') }}
    </span>
  </Modal>
</template>
<script>

import Modal from '@/components/common/Modal.vue'

export default {
  name: 'LocalPaymentsAddPayeeFailure',
  components: {
    Modal
  },
  props: {
    displayError: Boolean,
    errors: Array,
    retryActive: Boolean
  },
  data () {
    return {
      errorList: [],
      enableAddPayeeRetryLimit: this.$appSettings.defaultConfigurations.localPayments.enableAddPayeeRetryLimit,
      addPayeeRetryLimit: this.$appSettings.defaultConfigurations.localPayments.addPayeeRetryLimit,
      modalConfig: {
        addPayeeFailure: {
          enabled: true,
          title: this.$t("domesticPayments.addNewPayeeErrorTitle"),
          persistent: true,
          btn1Label: this.$t('common.okay'),
          width: 600
        }
      }
    }
  },
  computed: {
    resource () {
      return {
        retryButton: this.$t('common.retry')
      }
    }
  }
}
</script>
